import React, { useState, useRef, useEffect } from "react";
import groupIcon from '@/public/svg/group.svg';
import expandVertical from "@/public/svg/move-expand-vertical.svg";

interface CategoryProps {
  categories: Record<string, string>[];
  value: string;
  onChange: (value: string) => void;
}

const CategorySelect: React.FC<CategoryProps> = ({ categories, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const selected = categories.find((c) => c.name === value);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full" ref={wrapperRef}>
      <span className="absolute inset-y-0 left-3 flex items-center text-gray-400 pointer-events-none">
        <img src={groupIcon} alt="Group Icon" loading="lazy" />
      </span>

      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between w-full border border-gray-300 rounded-md px-3 py-2 hover:border-gray-400 transition"
      >
        <span className="flex items-center gap-2 text-gray-700 mx-8">
          {selected ? (
            <img src={selected.icon} alt="" className="w-5 h-5" />
          ) : (
            <span className="text-gray-400">Kategorie wählen</span>
          )}
          <span>{selected?.name}</span>
        </span>
      </button>

      {open && (
        <ul className="absolute left-0 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-20 max-h-64 overflow-y-auto">
          {categories.map((cat) => (
            <li
              key={cat.name}
              onClick={() => {
                onChange(cat.name);
                setOpen(false);
              }}
              className="flex items-center gap-3 px-3 py-2 hover:bg-gray-100 cursor-pointer"
            >
              <img src={cat.icon} alt="" className="w-5 h-5" />
              <span>{cat.name}</span>
            </li>
          ))}
        </ul>
      )}

      <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-400">
        <img src={expandVertical} alt="Search Icon" loading="lazy" />
      </span>
    </div>
  );
};

export default CategorySelect;
